import Vue from "vue";
import Router from "vue-router";
import Index from "@/pages/Index";
import Schedule from "@/pages/Schedule";
import Rank from "@/pages/Rank";
import Last from "@/pages/Last";
import Center from "@/pages/Center";
import Pro from "@/pages/Pro";
import Data from "@/pages/Data";
// import Example from '@/pages/Example';

Vue.use(Router);

export default new Router({
  // mode: 'history',

  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/schedule",
      name: "Schedule",
      component: Schedule,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/rank",
      name: "Rank",
      component: Rank,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/last",
      name: "Last",
      component: Last,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/center",
      name: "Center",
      component: Center,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/data",
      name: "Data",
      component: Data,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pro/:id",
      name: "Pro",
      component: Pro,
      meta: {
        keepAlive: false,
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js